// extracted by mini-css-extract-plugin
export default {"image_upload":"styles_image_upload__VdBcd","disabled_upload":"styles_disabled_upload__l7ObV"};